import { currentFrontend } from "../../store/UserStore";
import axios, { AxiosError } from "axios";

// Основной модуль для http запросов
export const api = axios.create();

api.interceptors.request.use(function (config) {
  const token = currentFrontend.userStore?.token;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    // Проверяем наличие нового токена в заголовках
    const newToken = response.headers.authorization;
    if (newToken?.startsWith("Bearer ")) {
      // Сохраняем новый токен
      const token = newToken.replace("Bearer ", "");
      currentFrontend.userStore?.updateToken(token);
    }

    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error instanceof AxiosError) {
      if (
        (error.status === 401 || error.status === 403) &&
        window.location.hash !== "#/auth/login"
      ) {
        currentFrontend.userStore?.resetUser();
      }
    }

    return Promise.reject(error);
  }
);
